import { render } from "./SelectorLevelView.vue?vue&type=template&id=2b7c4a13"
import script from "./SelectorLevelView.vue?vue&type=script&lang=js"
export * from "./SelectorLevelView.vue?vue&type=script&lang=js"

import "./SelectorLevelView.vue?vue&type=style&index=0&id=2b7c4a13&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__